import React from "react";
import Card from "../ui/Card";
import Image from "../ui/Image";
import {
  MessageCircle,
  Palette,
  Layout,
  Pencil,
} from "lucide-react";

import '../../styles/chat.css';

import PropTypes from "prop-types";

import { useAgentStore } from "../../store/agentStore";


const ChatboxSettingsCard = ({
  onEdit = () => {},
  chatboxSettings: chatboxSettingsProp,
}) => {
  const { selectedAgent } = useAgentStore();

  const chatboxSettings =  selectedAgent?.settings || chatboxSettingsProp || {};


  if (Object.keys(chatboxSettings).length === 0) {
    return <h3>Add Chatbox Settings</h3>;
  }

  return (
    <Card className="property-card m-0 h-100 position-relative">
      {/* HEADER */}
      <div className="card-header d-flex justify-content-between align-items-center ">
        <h3>Chatbox Settings</h3>
          <div className="property-actions">
        <button onClick={onEdit}>
          <Pencil size={18} className="text-slate-600" />
          </button>
        </div>
        
      </div>

      {/* ✅ LOGO FULL WIDTH */}
      {chatboxSettings.logo_url && (
        <div className="chatbox-logo-wrapper">
          {chatboxSettings.logo_url && <Image
            src={chatboxSettings.logo_url}
            alt="Chatbox Logo"
            className="chatbox-logo"
          />}
        </div>
      )}

      {/* SETTINGS */}
      <div className="chatbox-settings">
        {/* Greeting */}
        <div className="setting-row">
          <MessageCircle size={16} className="setting-icon" />

          <div className="setting-content">
            <span className="setting-label">Greeting</span>
            <span className="setting-value">
              {chatboxSettings.greeting}
            </span>
          </div>
        </div>

        <div className="grid-auto-fit">
          {/* Primary Color */}
          <div className="setting-row">
            <Palette size={16} className="setting-icon" />

            <div className="setting-content">
              <span className="setting-label">Primary Color</span>

              <div className="color-preview">
                <span
                  className="color-dot"
                  style={{ background: chatboxSettings.primary_color }}
                />
                {chatboxSettings.primary_color}
              </div>
            </div>
          </div>

          {/* Secondary Color */}
          <div className="setting-row">
            <Palette size={16} className="setting-icon" />

            <div className="setting-content">
              <span className="setting-label">Secondary Color</span>

              <div className="color-preview">
                <span
                  className="color-dot"
                  style={{ background: chatboxSettings.secondary_color }}
                />
                {chatboxSettings.secondary_color}
              </div>
            </div>
          </div>

          {/* Position */}
          <div className="setting-row">
            <Layout size={16} className="setting-icon" />

            <div className="setting-content">
              <span className="setting-label">Position</span>
              <span className="setting-value">
                {chatboxSettings.position}
              </span>
            </div>
          </div>

          {/* X-Axis */}
          <div className="setting-row">
            <span className="setting-label">X-Axis</span>
            <span className="setting-value">
              {chatboxSettings.x_axis}
            </span>
          </div>

          {/* Y-Axis */}
          <div className="setting-row">
            <span className="setting-label">Y-Axis</span>
            <span className="setting-value">
              {chatboxSettings.y_axis}
            </span>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default ChatboxSettingsCard;

/* ✅ Prop Validation */
ChatboxSettingsCard.propTypes = {
  onEdit: PropTypes.func.isRequired,
  chatboxSettings: PropTypes.object,
};